export default __webpack_public_path__ + "static/back-7bdbe1359f07ffd1150e5087a48cfb3d.png";